import {
  ESCRITORIOS_ADMIN_CATALOGO,
  ESCRITORIOS_BACKOFFICE,
} from '@modules/solicitacoes/constants/comunicacao'

// FONTE ÚNICA de verdade: o usuário logado pertence a um escritório de
// BACKOFFICE (executor da Operação AAWZ)?
//
// Centraliza a checagem que antes vivia (divergente) em 4 lugares: o gate da
// rota da Operação AAWZ (solicitacoes/routes → ehEscritorioOperacaoAawz), o modo
// RESPONDER da Comunicação (view-comunicacao → isResponder), o guard das
// Configurações de Solicitações (settings/routes) e o card de Solicitações do
// settings (view-home-v2). Cada um reimplementava com critério diferente — uns
// exigiam IS_INTERNAL, uns comparavam id_interno sem Number() — o que derrubava
// o executor para a visão de cliente (endpoints externos, tela vazia).
//
// Até 27/08/2026 aceitava SÓ o interno (2976). Passou a aceitar também o
// escritório de teste (83) por decisão explícita do usuário: "tratar o 83 igual
// ao interno, nas mesmas condições e tudo mais". O nome ficou por causa dos
// call-sites; quem manda é `ESCRITORIOS_BACKOFFICE`, espelhado do backend.
//
// Critério: `escritorio.id_interno` com Number() (o backend pode devolver o id
// como string) e default-closed — id ausente ou não numérico retorna false, para
// não liberar o executor por engano.
export const ehEscritorioInternoAawz = (user) => {
  const escritorio = (user && user.escritorio) || {}
  const idEscritorio = Number(escritorio.id_interno)
  if (!idEscritorio) return false
  return ESCRITORIOS_BACKOFFICE.includes(idEscritorio)
}

// Quem ADMINISTRA o catálogo de serviços (Configurações > Solicitações, com as
// 4 abas de parametrização — incluindo o Catálogo Backoffice): o interno AAWZ
// (2976) MAIS o escritório de teste do time (83).
//
// Hoje resolve a MESMA lista de `ehEscritorioInternoAawz`: os dois helpers
// existiam separados porque o 83 administrava o catálogo sem ver a Operação
// AAWZ, e essa distinção acabou em 27/08/2026 com a equiparação. O nome próprio
// fica para o dia em que voltarem a divergir — e para deixar legível, no
// call-site, QUAL autorização está sendo pedida.
//
// Mesmo critério de `ehEscritorioInternoAawz`: `escritorio.id_interno` com
// Number() (o backend pode devolver o id como string) e default-closed.
export const podeAdministrarCatalogo = (user) => {
  const escritorio = (user && user.escritorio) || {}
  const idEscritorio = Number(escritorio.id_interno)
  if (!idEscritorio) return false
  return ESCRITORIOS_ADMIN_CATALOGO.includes(idEscritorio)
}
